import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getGoogleAuthUrl } from "./constants";

export function DeliveryNavbar({ user }) {
  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo-new.png" alt="Setuxpress" className="h-10" />
            
          </Link>
          
          <div className="hidden md:flex items-center gap-6">
            <Link to="/browse" className="text-sm font-medium hover:text-accent">Cargo Space</Link>
            <Link to="/private-jets" className="text-sm font-medium hover:text-accent">Private Jets</Link>
            <Link to="/local-delivery" className="text-sm font-medium text-accent">Local Delivery</Link>
          </div>

          {user ? (
            <Link to={user.user_type === "partner" ? "/partner" : "/dashboard"}>
              <Button className="rounded-none" data-testid="dashboard-btn">Dashboard</Button>
            </Link>
          ) : (
            <a href={getGoogleAuthUrl()}>
              <Button className="rounded-none bg-accent text-accent-foreground hover:bg-accent/90" data-testid="signin-btn">
                Sign In
              </Button>
            </a>
          )}
        </div>
      </div>
    </nav>
  );
}
